import SmallMultiple from "./SmallMultiple/SmallMultipleMain";

const WindSmallMultipleLocation = ({ title, location_key, colors }) => {
  const items = [
        {
            title: "< 2 MW", 
            explanationText: `Windkraftanlagen unter 2 Megawatt stammen meist aus den 1990er- oder frühen 2000er-Jahren. 
            Sie gelten heute als technisch überholt und werden kaum noch neu gebaut. Dennoch sind viele dieser Anlagen noch
             in Betrieb und leisten einen Beitrag zur lokalen Stromversorgung.`, 
            size_category: "Power_0_2000"
          },
          { 
            title: "2-4 MW", 
            explanationText: `Diese Anlagenklasse bildet das Rückgrat vieler Windparks aus den letzten Jahren. Sie bieten 
            ein gutes Verhältnis von Leistung zu Flächenbedarf und sind vor allem im Onshore-Bereich weit verbreitet. 
            Ihre Verbreitung zeigt den technischen Fortschritt der Windkraft in den 2010er-Jahren.`, 
            size_category: "Power_2000_4000"  
          },
          { 
            title: "4-6 MW", 
            explanationText: `Windkraftanlagen dieser Klasse sind groß, effizient und bilden derzeit den Standard vieler 
            moderner Onshore-Windparks. Sie ermöglichen eine hohe Stromerzeugung bei gleichzeitig guter Flächennutzung. 
            Oft sind sie der Übergang zu noch leistungsstärkeren Anlagen ab 6 MW.`, 
            size_category: "Power_4000_6000"  
          },
          { 
            title: ">= 6 MW", 
            explanationText: `Diese Windkraftanlagen gehören zur neuesten Generation besonders leistungsstarker 
            Onshore-Turbinen. Sie erreichen Leistungen von über 6 Megawatt und ermöglichen eine maximale Stromausbeute 
            pro Standort. Solche Anlagen kommen meist in neueren Windparks mit optimierten Flächen zum Einsatz.`, 
            size_category: "Power_6000"  
          },
    ];
    
  return (
    <>
      <h3 className="text-xl mt-10 mb-2 font-semibold text-center">{title}</h3>
      <div className="flex flex-wrap justify-center gap-4 rounded-lg">
        {items.map(({ size_category, title, explanationText }, index) => (
          <div
            key={index}
            className="text-center flex-1 min-w-[220px] max-w-xs flex flex-col"
            style={{ flexBasis: "220px" }}
          >
            <SmallMultiple
              textData={{
                summary: title,
                popoverText: explanationText,
              }}
              donutSpec={title}
              location_key={location_key}
              energySource={"wp"}
              unit={"MW"}
              smallMultipleType="size"
              LineChartTitle={'Installierte Leistung in MW'}
              category={size_category}
              colors={colors}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default WindSmallMultipleLocation;
